export enum MailingChannelEnum {
  TELEGRAM = 'TELEGRAM',
  WHATSAPP = 'WHATSAPP',
  EMAIL = 'EMAIL',
  SMS = 'SMS'
}
